module.exports = __webpack_public_path__ + "static/media/linkdin.32b143bf.svg";